import React from 'react';
import { Box } from '@mui/material';
import { spacing } from '../../constants';

const MicrosoftIcon = () => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: spacing.md,
      height: spacing.md,
      mr: spacing.sm,
    }}
  >
    <svg width="20" height="20" viewBox="0 0 23 23" fill="none">
      <path fill="#f25022" d="M0 0h11v11H0z" />
      <path fill="#00a4ef" d="M12 0h11v11H12z" />
      <path fill="#7fba00" d="M0 12h11v11H0z" />
      <path fill="#ffb900" d="M12 12h11v11H12z" />
    </svg>
  </Box>
);

export default MicrosoftIcon;









